import axios from 'axios'

const API =  {
    getData: () =>
    axios({
        'method':'GET',
        'url':'http://worldtimeapi.org/api/timezone',
        'headers': {
            'content-type':'application/octet-stream',
        }
    }),
    getCountryState:()=>
    axios({
        'method': 'GET',
        'url':'https://countriesnow.space/api/v0.1/countries/states',
        'headers': {
            'content-type':'application/octet-stream',
        }
    })
}
export default API